export default "__VITE_ASSET__BOMjSKvV__"